<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col lg="6" sm="10" md="10" style="padding: 0; margin:0 !important;">
            <p style="text-align: left;">{{ $t("nameReport") }}</p>
            <v-text-field
              solo
              style="width: 100%;"
              readonly
              :label="$t('nameReport')"
              append-icon="mdi-file"
              :color="colorTheme"
              v-model="NameOfReport"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col lg="6" sm="10" md="10" style="padding: 0; margin:0 !important;">
            <p style="text-align: left;">{{ $t("period") }}</p>
            <v-text-field
              solo
              readonly
              :label="$t('period')"
              append-icon="mdi-calendar"
              :color="colorTheme"
              v-model="PeriodOfReportTitle"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row align="center" justify="center" style="margin:0 !important;">
          <v-col lg="3" sm="5" md="5" cols="12" style="padding: 0; display: table-cell; ">
            <p style="text-align: left;">{{ $t("selectV") }}</p>
            <v-text-field
              style="width: 100%;padding-right: 5px;"
              solo
              readonly
              v-model="NoVehicles"
              :label="$t('selectV')"
              append-icon="mdi-car"
              :color="colorTheme"
            ></v-text-field>
          </v-col>
          <v-col lg="3" sm="5" md="5" cols="12" style="padding: 0; display: table-cell;">
            <p style="text-align: left;">{{ $t("type2") }}</p>
            <v-text-field
              style="width: 100%;"
              solo
              readonly
              v-model="TypeOfReport"
              :label="$t('type2')"
              append-icon="mdi-car"
              :color="colorTheme"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row align="center" justify="center" style="margin:0 !important;">
          <v-col lg="6" sm="10" md="10" style="padding: 0; display: table-cell;">
            <p style="text-align: left;">{{ $t("sendEmail") }}</p>
            <v-combobox
              v-model="Emails"
              :label="$t('sendEmail')"
              chips
              solo
              multiple
              append-icon
              prepend-inner-icon="mdi-email-outline"
              :color="colorTheme"
              ref="form"
              readonly
            ></v-combobox>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col lg="6" sm="10" md="10" style="padding: 0; margin:0 !important;">
            <p style="font-size: smaller; text-align: center;">{{ $t("MessageReport") }}</p>
          </v-col>
        </v-row>
      </v-col>
      <v-overlay absolute="true" v-model="finish">
        <v-card width="300" :light="overlayCard">
          <v-card-text v-if="!showMessage" style="padding-top: 20px; text-align: -webkit-center;">
            {{ $t("await") }}
            <v-progress-circular
              class="mb-0"
              :size="70"
              :width="4"
              indeterminate
              :color="colorTheme"
              style="display: flex;"
            ></v-progress-circular>
          </v-card-text>

          <v-card-text v-else style="padding-top: 20px; text-align: -webkit-center;">
            {{ $t("confirmation") }}
            <v-progress-circular
              class="mb-0"
              :size="70"
              :width="4"
              :value="100"
              :color="colorTheme"
              style="display: flex;"
            >
              <v-icon size="50" :color="colorTheme">mdi-check</v-icon>
            </v-progress-circular>
          </v-card-text>
          <v-divider></v-divider>
          <!-- <v-card-actions v-if="!showMessage">
            <v-btn :color="colorTheme" text v-on:click="cancel()">{{$t("cancel").toUpperCase()}}</v-btn>
          </v-card-actions>-->

          <v-card-actions v-if="showMessage">
            <v-btn :color="colorTheme" text v-on:click="back()">
              {{
              $t("accept").toUpperCase()
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-overlay>
      <v-overlay absolute="true" opacity="0" v-model="errorMessage">
        <v-card width="300" :light="overlayCard">
          <v-card-text style="padding-top: 20px;">
            {{
            errorMessageText
            }}
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-btn text :color="colorTheme" v-on:click="close()">
              {{
              $t("accept").toUpperCase()
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-overlay>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";

export default {
  name: "summaryReport",
  data: () => ({}),
  computed: {
    ...mapState([
      "NameOfReport",
      "Emails",
      "PeriodOfReportTitle",
      "startDateReport",
      "endDateReport",
      "TypeOfReport",
      "colorTheme",
      "finish",
      "overlayCard"
    ]),
    showMessage: {
      get: function() {
        return this.$store.state.showMessage;
      },
      set: function() {
        this.$store.commit("showMessage", [false, false]);
      }
    },
    errorMessage: {
      get: function() {
        return this.$store.state.errorMessage;
      },
      set: function() {
        this.$store.commit("errorMessage", false);
      }
    },
    errorMessageText: {
      get: function() {
        return this.$store.state.errorMessageText;
      },
      set: function() {}
    },
    NoColumns: {
      get: function() {
        return this.$store.state.vehicles.length;
      },
      set: function() {}
    },
    NoVehicles: {
      get: function() {
        return this.$store.state.vehicles.length;
      },
      set: function() {}
    }
  },
  created() {},
  mounted() {
    this.$store.commit("backgroundCard");
  },
  methods: {
    cancel() {
      this.$store.commit("showMessage", [false, false]);
    },
    back() {
      this.$store.commit("showMessage", [false, false]);
      this.$store.commit("setAccount", false);
      this.$router.replace({ name: "reportsPage" });
    },
    close() {
      this.$store.commit("errorMessage", false);
    }
  }
};
</script>

<style lang="scss">
.v-progress-circular {
  margin: 1rem;
}
</style>
